import { Permission } from '@/types/session'
import { create } from 'zustand'

interface PermissionsStore {
    permissions: Permission[]
    setPermissions: (permissions: Permission[]) => void
    isAdmin: boolean
    setIsAdmin: (isAdmin: boolean) => void
    canFilterCustomerEventFollowers: boolean
    setCanFilterCustomerEventFollowers: (canFilter: boolean) => void
    canDeleteCustomerJourneyNote: boolean
    setCanDeleteCustomerJourneyNote: (canDelete: boolean) => void
    canDeletePlainNotesOnlyCustomerJourney: boolean
    setCanDeletePlainNotesOnlyCustomerJourney: (canDelete: boolean) => void
    canViewLeadOriginCustomers: boolean
    setCanViewLeadOriginCustomers: (canView: boolean) => void
}

const usePermissionsStore = create<PermissionsStore>((set) => ({
    permissions: [],
    setPermissions(permissions) {
        set({ permissions })
    },
    isAdmin: false,
    setIsAdmin(isAdmin) {
        set({ isAdmin })
    },
    canFilterCustomerEventFollowers: false,
    setCanFilterCustomerEventFollowers(canFilter) {
        set({ canFilterCustomerEventFollowers: canFilter })
    },
    canDeleteCustomerJourneyNote: false,
    setCanDeleteCustomerJourneyNote(canDelete) {
        set({ canDeleteCustomerJourneyNote: canDelete })
    },
    canDeletePlainNotesOnlyCustomerJourney: false,
    setCanDeletePlainNotesOnlyCustomerJourney(canDelete) {
        set({ canDeletePlainNotesOnlyCustomerJourney: canDelete })
    },
    canViewLeadOriginCustomers: false,
    setCanViewLeadOriginCustomers(canView) {
        set({ canViewLeadOriginCustomers: canView })
    },
}))

export default usePermissionsStore
